import React, { useEffect, useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Variations = ({ data }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [properties, setProperties] = useState([]);
  const [variationCount, setVariationCount] = useState(10);
  const [hasSalesPercentage, setHasSalesPercentage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAsin, setSelectedAsin] = useState(null);
  const [hasImages, setHasImages] = useState(false);
  const navigate = useNavigate();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (data) {
      const attributes = data[0]?.attributes;
      const properties =
        attributes?.map((attribute) => attribute?.dimension) || [];

      setProperties(properties);
      setHasSalesPercentage(
        data.some((v) => v.salesData && v.salesData.salesPercentage)
      );
      setHasImages(data.some((v) => v.image));
    }
  }, [data]);

  const handleRowClick = (asin) => {
    setSelectedAsin(asin);
    setShowModal(true);
  };

  const handleConfirm = () => {
    if (selectedAsin) {
      navigate(`/dashboard?asin=${selectedAsin}`);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    setSelectedAsin(null);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="">
        <div
          className="flex cursor-pointer items-center mb-2 justify-between"
          onClick={toggleAccordion}
        >
          <div className="mr-1 text-primary text-md font-bold">Variations </div>
          <div className="text-primary">
            {isOpen ? (
              <MdExpandMore className="w-6 h-6" />
            ) : (
              <MdExpandLess className="w-6 h-6" />
            )}
          </div>
        </div>
        {isOpen && (
          <div className="bg-primary-bg rounded-xl">
            <table className="w-full mt-2">
              <thead>
                <tr className="text-xs font-semibold">
                  <div className="flex bg-secondary-bg rounded-lg py-1.5 mb-2 text-center text-white">
                    <div className="p-1 flex-2"></div>
                    {hasImages && <div className="p-1 flex-1">Image</div>}
                    <div className="p-1 flex-1">Asin</div>
                    {properties.map((property, index) => (
                      <div className="p-1 flex-1" key={index}>
                        {property}
                      </div>
                    ))}
                    {hasSalesPercentage && (
                      <div className="p-1 flex-1">Sales %</div>
                    )}
                  </div>
                </tr>
              </thead>
              <tbody>
                {data?.slice(0, variationCount)?.map((property, index) => (
                  <tr
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(property?.asin)}
                  >
                    <td className="p-0">
                      <div
                        className="text-center text-xs text-white bg-secondary-bg p-4 rounded-lg border border-primary/20 hover:border-primary transition duration-300"
                        style={{
                          marginTop: index === 0 ? "0" : "10px",
                          marginBottom: "0",
                          padding: "6px 10px",
                        }}
                      >
                        <div className="flex items-center justify-around">
                          <div className="pl-0 pr-2 flex-2">{index + 1}</div>{" "}
                          {hasImages && (
                            <div className="flex-1 flex justify-center items-center">
                              {property?.image ? (
                                <img
                                  src={property.image}
                                  alt="variation"
                                  style={{
                                    width: 40,
                                    height: 40,
                                    objectFit: "contain",
                                    borderRadius: 8,
                                    background: "white",
                                  }}
                                />
                              ) : (
                                <span>-</span>
                              )}
                            </div>
                          )}
                          <div className=" flex-1">{property?.asin || "-"}</div>
                          {property?.attributes?.map((item, idx) => (
                            <div key={idx} className=" flex-1">
                              {item?.value}
                            </div>
                          ))}
                          {hasSalesPercentage && (
                            <div className=" flex-1">
                              {property?.salesData?.salesPercentage
                                ? `${property.salesData.salesPercentage}%`
                                : "-"}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
                {variationCount < data?.length ? (
                  <div className="flex justify-center">
                    <button
                      onClick={() => setVariationCount((prev) => prev + 5)}
                      className="mt-3 px-3 py-1 text-xs bg-primary/10 text-primary border border-primary/80 rounded-md"
                    >
                      Load More
                    </button>
                  </div>
                ) : null}
              </tbody>
            </table>

            {showModal && (
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div
                  className="absolute inset-0 bg-black opacity-50"
                  onClick={handleCancel}
                ></div>
                <div className="bg-primary-bg border border-primary rounded-lg p-6 z-10 max-w-sm w-[90%] mx-auto">
                  <p className="font-Inter text-md font-semibold text-white">
                    Confirm
                  </p>
                  <p className="font-Inter mt-2 text-sm text-white">
                    Do you want to open{" "}
                    <b className="text-primary">{selectedAsin}</b>?
                  </p>
                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      className="bg-primary-bg text-primary cursor-pointer px-4 py-1 rounded border border-primary hover:bg-primary/10 transition duration-300"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      className="bg-primary/30 text-primary font-semibold cursor-pointer px-4 py-1 rounded hover:bg-primary/70 hover:text-primary transition duration-300"
                      onClick={handleConfirm}
                    >
                      Open
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Variations;
